/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.global.styles.rpc.GlobalStylesRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const BrightnessOffsetModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.BrightnessOffsetModifier';
export const ShadeModifierTypename = 'com.hubspot.content.model.customwidgets.inherited.ShadeModifier';
export const NotFoundErrorTypename = 'com.hubspot.global.styles.models.rpc.NotFoundError';
export const ValidationErrorTypename = 'com.hubspot.global.styles.models.rpc.ValidationError';
export const getRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'get',
  auth: 'app',
  fingerprint: 'TT2Ful4GP6ytZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'kuA9D4VTYGStZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'se7en4KxZvetZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const archiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'archive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv0XXRyap94UHyeSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unarchiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'unarchive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv2tZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'hasBufferedChanges',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv1_c7OzYhY5UCeSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getBuffer',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv2tZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getPortalBuffer',
  auth: 'app',
  fingerprint: 'k-8GcWPsH7atZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertBufferRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'upsertBuffer',
  auth: 'app',
  fingerprint: 'zJgUFvM-4EmtZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'pushBufferLive',
  auth: 'app',
  fingerprint: 'IBKJIWwCMv2tZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMergedGlobalStylesRpc = {
  serviceName: 'com.hubspot.global.styles.rpc.GlobalStylesRpc',
  rpcName: 'getMergedGlobalStyles',
  auth: 'app',
  fingerprint: '9jWzWHXIbzWtZ7v_GYmG9ieSQq49Y5nB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};